import React from "react";

const Pagination = ({ totalPages = 1, currentPage = 1, onChange }) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  return (
    <div className="pagination" aria-label="Pages">
      {pages.map((n) => (
        <button
          key={`page-${n}`}
          className={`page ${currentPage === n ? "active" : ""}`}
          onClick={() => onChange && onChange(n)}
        >
          {n}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
